import { deleteDB, openDB, type DBSchema } from "idb";
import type { RecoveryDraft, StoredMacroV1 } from "./types";

interface EditorDB extends DBSchema {
  macros: { key: string; value: StoredMacroV1 };
  drafts: { key: string; value: RecoveryDraft };
}

const db = () => openDB<EditorDB>("local-macro-editor", 1, {
  upgrade(database) { database.createObjectStore("macros", { keyPath: "id" }); database.createObjectStore("drafts", { keyPath: "id" }); }
});

export const storage = {
  async macros() { return (await db()).getAll("macros"); },
  async replaceMacros(macros: StoredMacroV1[]) { const tx = (await db()).transaction("macros", "readwrite"); await tx.store.clear(); await Promise.all(macros.map((macro) => tx.store.put(macro))); await tx.done; },
  async saveMacro(macro: StoredMacroV1) { await (await db()).put("macros", macro); },
  async deleteMacro(id: string) { await (await db()).delete("macros", id); },
  async draft() { return (await db()).get("drafts", "current"); },
  async saveDraft(draft: RecoveryDraft) { await (await db()).put("drafts", draft); },
  async clearDraft() { await (await db()).delete("drafts", "current"); },
  async clearAll() { (await db()).close(); await deleteDB("local-macro-editor"); localStorage.removeItem("lme-preferences"); }
};
